import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { CustomShippingRateModalPages } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/components/CustomShippingRateModal/hooks/useCustomShippingRateModalPages';
import { LIVE_SHIPPING_METHOD_TRANSLATION_KEY } from '@/components/ShippingInfo/LiveShippingInfo/components/ShippingPickupOptions/components/LiveShipping/LiveShippingMethodRow.constants';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';
import styled from 'styled-components';

export type CustomShippingRateSuccessProps = {
    onClose: () => void;
};

const CustomShippingRateSuccess = ({ onClose }: CustomShippingRateSuccessProps) => {
    const { formatMessage } = useIntl();

    return (
        <section>
            <StyledCloseButton onClick={onClose}>
                {formatMessage({
                    id: `${LIVE_SHIPPING_METHOD_TRANSLATION_KEY}.customShippingRateModal.${CustomShippingRateModalPages.TooExpensiveRequestSuccess}.close`,
                })}
            </StyledCloseButton>
        </section>
    );
};

export default CustomShippingRateSuccess;

const StyledCloseButton = styled(Button)`
    margin-left: auto;
    margin-right: auto;
`;
